import Div from "@jumbo/shared/Div";
import {
  Autocomplete,
  Box,
  Button,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { dateFun } from "app/utils/constants/functions";
import dayjs from "dayjs";

import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrders } from "app/redux/actions/orderAction";

import axios from "axios";
import { downloadYearlySalesListReport } from "app/services/apis/ReportApis/Sales/YearlySalesReport";
import { downloadReceivePendingOrderReport } from "app/services/apis/ReportApis/AllReport/receivePending";
import { downloadJobWorkIssueDetailsReport } from "app/services/apis/ReportApis/AllReport/jobWorkIssueDetails";
import { downloadJobWorkDraftReport } from "app/services/apis/ReportApis/AllReport/jobWorkDraft";
import { downloadAlterationReport, getAlterationReportStatuses } from "app/services/apis/ReportApis/AllReport/alterationReport";
import { getFactoryNameList } from "app/services/apis/ListApi/factoryNameList";
import { getPortListNoPerm } from "app/services/apis/ListApi/portListNoPerm";
import { getSalesPersonList } from "app/services/apis/salesPersonDropdown";
import {
  downloadSalesOrderReport,
  getSalesOrderReportMonths,
  getSalesOrderReportPorts,
  getSalesOrderReportSalespersons,
  getSalesOrderReportYears,
} from "app/services/apis/ReportApis/Sales/SalesOrderReport";
import {
  downloadShipmentPackingListReport,
  getShipmentPackingListBoxes,
  getShipmentPackingListPorts,
  getShipmentPackingListShipments,
} from "app/services/apis/ReportApis/AllReport/shipmentPackingList";
import {
  downloadInventoryStockSummaryReport,
  getInventoryStockSummaryInvoices,
  getInventoryStockSummaryMonths,
  getInventoryStockSummaryYears,
} from "app/services/apis/ReportApis/AllReport/inventoryStockSummary";
import Swal from "sweetalert2";

const REPORT_TYPES = [
  "Sales Report",
  "Sales Order Report",
  "Receive Pending Order Report",
  "Job Work Issue Details Report",
  "Job Work Draft Report",
  "Alteration Report",
  "Shipment Number Wise Packing List Report",
  "Inventory Stock Summary",
];

const ORDER_TYPES = ["All", "Normal Order", "Shop Order"];

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const currentYear = new Date().getFullYear();
const YEARS = Array.from({ length: 15 }, (_, i) => String(currentYear - i));

const fieldWidth = { width: "23%" };

const pickerSx = {
  width: "100%",
  "& .MuiInputBase-root": {
    height: "39px",
    flexDirection: "unset",
  },
};

const SalesYearlyReport = () => {
  const [reportType, setReportType] = useState("Sales Report");
  const [inputs, setInputs] = useState({});
  const [yearList, setYearList] = useState([]);
  const [mnthList, setMnthList] = useState([]);
  const [salesOrderYearList, setSalesOrderYearList] = useState([]);
  const [salesOrderMonthList, setSalesOrderMonthList] = useState([]);
  const [portList, setPortList] = useState([]);
  const [salesPersonList, setSalesPersonList] = useState([]);
  const [shipmentNoList, setShipmentNoList] = useState([]);
  const [boxNoList, setBoxNoList] = useState([]);
  const [shipmentPortList, setShipmentPortList] = useState([]);
  const [factoryList, setFactoryList] = useState([]);
  const [alterationStatusList, setAlterationStatusList] = useState([]);
  const [inventoryYearList, setInventoryYearList] = useState([]);
  const [inventoryMonthList, setInventoryMonthList] = useState([]);
  const [inventoryInvoiceList, setInventoryInvoiceList] = useState([]);

  const isSalesOrderReport = reportType === "Sales Order Report";
  const isReceivePending = reportType === "Receive Pending Order Report";
  const isJobWorkIssueDetails = reportType === "Job Work Issue Details Report";
  const isAlterationReport = reportType === "Alteration Report";
  const isShipmentPackingList =
    reportType === "Shipment Number Wise Packing List Report";
  const isInventoryStockSummary = reportType === "Inventory Stock Summary";
  const usesDateAndMonthYear =
    isSalesOrderReport ||
    isReceivePending ||
    isInventoryStockSummary ||
    isAlterationReport;
  const hasDateRange = usesDateAndMonthYear && Boolean(inputs.from || inputs.to);
  const hasMonthYear = usesDateAndMonthYear && Boolean(inputs.year || inputs.month);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    if (usesDateAndMonthYear && (name === "month" || name === "year")) {
      setInputs((values) => ({
        ...values,
        [name]: value,
        ...(name === "year" && (isSalesOrderReport || isInventoryStockSummary)
          ? { month: "" }
          : {}),
        from: "",
        to: "",
        ...(isInventoryStockSummary ? { invoice_no: null } : {}),
      }));
      return;
    }
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const handleFilter = async () => {
    if (reportType === "Receive Pending Order Report") {
      if ((inputs.from && !inputs.to) || (!inputs.from && inputs.to)) {
        return Swal.fire({ icon: "warning", title: "Select From and To Date" });
      }
      if (inputs.month && !inputs.year) {
        return Swal.fire({ icon: "warning", title: "Select Year" });
      }
      const requestParams = {
        ...inputs,
        salesman_name: inputs.sales_person?.full_name || "",
        port_no_and_name: inputs.port_no_and_name || "",
      };
      const data = await downloadReceivePendingOrderReport(requestParams);
      if (data) {
        window.open(data, "_blank");
      } else {
        Swal.fire({ icon: "error", title: "No Result Found" });
      }
      return;
    }
    if (reportType === "Job Work Issue Details Report") {
      if ((inputs.from && !inputs.to) || (!inputs.from && inputs.to)) {
        return Swal.fire({ icon: "warning", title: "Select From and To Date" });
      }
      if (inputs.from && inputs.to && inputs.from > inputs.to) {
        return Swal.fire({
          icon: "warning",
          title: "From Date cannot be greater than To Date",
        });
      }
      if (inputs.month && !inputs.year) {
        return Swal.fire({ icon: "warning", title: "Select Year" });
      }
      try {
        const data = await downloadJobWorkIssueDetailsReport(inputs);
        if (data) {
          window.open(data, "_blank");
        } else {
          Swal.fire({ icon: "error", title: "No Result Found" });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: error?.response?.data?.message || "No Result Found",
        });
      }
      return;
    }
    if (reportType === "Job Work Draft Report") {
      if ((inputs.from && !inputs.to) || (!inputs.from && inputs.to)) {
        return Swal.fire({ icon: "warning", title: "Select From and To Date" });
      }
      if (inputs.from && inputs.to && inputs.from > inputs.to) {
        return Swal.fire({
          icon: "warning",
          title: "From Date cannot be greater than To Date",
        });
      }
      if (inputs.month && !inputs.year) {
        return Swal.fire({ icon: "warning", title: "Select Year" });
      }
      try {
        const data = await downloadJobWorkDraftReport(inputs);
        if (data) {
          window.open(data, "_blank");
        } else {
          Swal.fire({ icon: "error", title: "No Result Found" });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: error?.response?.data?.message || "No Result Found",
        });
      }
      return;
    }
    if (reportType === "Alteration Report") {
      if ((inputs.from && !inputs.to) || (!inputs.from && inputs.to)) {
        return Swal.fire({ icon: "warning", title: "Select From and To Date" });
      }
      if (inputs.from && inputs.to && inputs.from > inputs.to) {
        return Swal.fire({
          icon: "warning",
          title: "From Date cannot be greater than To Date",
        });
      }
      if (inputs.month && !inputs.year) {
        return Swal.fire({ icon: "warning", title: "Select Year" });
      }
      try {
        const requestParams = {
          ...inputs,
          factory_id: inputs.factory?.id || inputs.factory_id || "",
          factory_name:
            inputs.factory?.factory_name ||
            inputs.factory_name ||
            inputs.order_item_factory_name ||
            "",
          port_no_and_name: inputs.port_no_and_name || "",
          order_item_status: inputs.order_item_status || "",
          salesman_id: inputs.sales_person?.id || "",
          salesman_name: inputs.sales_person?.full_name || "",
        };
        const data = await downloadAlterationReport(requestParams);
        if (data) {
          window.open(data, "_blank");
        } else {
          Swal.fire({ icon: "error", title: "No Result Found" });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: error?.response?.data?.message || "No Result Found",
        });
      }
      return;
    }
    if (reportType === "Sales Order Report") {
      if ((inputs.from && !inputs.to) || (!inputs.from && inputs.to)) {
        return Swal.fire({ icon: "warning", title: "Select From and To Date" });
      }
      const salesmanId = inputs.sales_person?.id;
      const salesmanName = inputs.sales_person?.full_name;
      if ((salesmanId && !salesmanName) || (!salesmanId && salesmanName)) {
        return Swal.fire({
          icon: "warning",
          title: "Salesman id and name both are required",
        });
      }
      const { url, message } = await downloadSalesOrderReport({
        from: inputs.from,
        to: inputs.to,
        year: inputs.year,
        month: inputs.month,
        port_no_and_name: inputs.port_no_and_name,
        salesman_id: salesmanId,
        salesman_name: salesmanName,
      });
      if (url) {
        window.open(url, "_blank");
      } else {
        Swal.fire({ icon: "error", title: message || "No Result Found" });
      }
      return;
    }
    if (reportType === "Shipment Number Wise Packing List Report") {
      const { url, message } = await downloadShipmentPackingListReport({
        order_type: inputs.order_type || "All",
        shipment_no: inputs.shipment_no,
        box_no: inputs.box_no,
        port_no: inputs.shipment_port_no,
      });
      if (url) {
        window.open(url, "_blank");
      } else {
        Swal.fire({ icon: "error", title: message || "No Result Found" });
      }
      return;
    }
    if (reportType === "Inventory Stock Summary") {
      if ((inputs.from && !inputs.to) || (!inputs.from && inputs.to)) {
        return Swal.fire({ icon: "warning", title: "Select From and To Date" });
      }
      if (inputs.month && !inputs.year) {
        return Swal.fire({ icon: "warning", title: "Select Year" });
      }
      const { url, message } = await downloadInventoryStockSummaryReport({
        from: inputs.from,
        to: inputs.to,
        year: inputs.year,
        month: inputs.month,
        invoice_no: inputs.invoice_no,
      });
      if (url) {
        window.open(url, "_blank");
      } else {
        Swal.fire({ icon: "error", title: message || "No Result Found" });
      }
      return;
    }
    if (reportType !== "Sales Report") return;
    let data = await downloadYearlySalesListReport(inputs);
    if (data) {
      window.open(data, "_blank");
    }
  };

  const handleClear = () => {
    setInputs({});
    if (isSalesOrderReport) {
      setSalesOrderMonthList([]);
    }
    if (isShipmentPackingList) {
      setBoxNoList([]);
      setShipmentPortList([]);
    }
    if (isInventoryStockSummary) {
      setInventoryMonthList([]);
      setInventoryInvoiceList([]);
    }
  };

  const handleReportTypeChange = (event) => {
    setReportType(event.target.value);
    setInputs({});
    setSalesOrderMonthList([]);
    setShipmentNoList([]);
    setBoxNoList([]);
    setShipmentPortList([]);
    setInventoryYearList([]);
    setInventoryMonthList([]);
    setInventoryInvoiceList([]);
    setAlterationStatusList([]);
  };

  useEffect(() => {
    if (
      reportType !== "Sales Order Report" &&
      reportType !== "Receive Pending Order Report" &&
      reportType !== "Alteration Report"
    )
      return;
    const loadDropdowns = async () => {
      if (reportType === "Alteration Report") {
        const [ports, salesPersons, statuses] = await Promise.all([
          getPortListNoPerm(),
          getSalesPersonList(),
          getAlterationReportStatuses(),
        ]);
        setPortList(ports || []);
        setSalesPersonList(
          (salesPersons || []).filter((person) =>
            /^\d+$/.test(String(person?.id ?? "").trim())
          )
        );
        setAlterationStatusList(statuses || []);
      } else if (reportType === "Receive Pending Order Report") {
        const [ports, salesPersons] = await Promise.all([
          getPortListNoPerm(),
          getSalesPersonList(),
        ]);
        setPortList(ports || []);
        setSalesPersonList(
          (salesPersons || []).filter((person) =>
            /^\d+$/.test(String(person?.id ?? "").trim())
          )
        );
      } else {
        const [years, ports, salesPersons] = await Promise.all([
          getSalesOrderReportYears(),
          getSalesOrderReportPorts(),
          getSalesOrderReportSalespersons(),
        ]);
        setSalesOrderYearList(years || []);
        setPortList(ports || []);
        setSalesPersonList(
          (salesPersons || []).filter((person) =>
            /^\d+$/.test(String(person?.id ?? "").trim())
          )
        );
      }
    };
    loadDropdowns();
  }, [reportType]);

  useEffect(() => {
    if (
      reportType !== "Job Work Issue Details Report" &&
      reportType !== "Receive Pending Order Report" &&
      reportType !== "Alteration Report"
    )
      return;
    const loadFactories = async () => {
      const factories = await getFactoryNameList();
      setFactoryList(factories || []);
    };
    loadFactories();
  }, [reportType]);

  useEffect(() => {
    if (reportType !== "Sales Order Report") return;
    const loadMonths = async () => {
      if (!inputs.year) {
        setSalesOrderMonthList([]);
        return;
      }
      const months = await getSalesOrderReportMonths(inputs.year);
      setSalesOrderMonthList(months || []);
    };
    loadMonths();
  }, [reportType, inputs.year]);

  useEffect(() => {
    if (reportType !== "Inventory Stock Summary") return;
    const loadYears = async () => {
      const years = await getInventoryStockSummaryYears();
      setInventoryYearList(years || []);
    };
    loadYears();
  }, [reportType]);

  useEffect(() => {
    if (reportType !== "Inventory Stock Summary") return;
    const loadMonths = async () => {
      if (!inputs.year) {
        setInventoryMonthList([]);
        return;
      }
      const months = await getInventoryStockSummaryMonths(inputs.year);
      setInventoryMonthList(months || []);
    };
    loadMonths();
  }, [reportType, inputs.year]);

  useEffect(() => {
    if (reportType !== "Inventory Stock Summary") return;
    const loadInvoices = async () => {
      const invoices = await getInventoryStockSummaryInvoices({
        from: inputs.from,
        to: inputs.to,
        year: inputs.year,
        month: inputs.month,
      });
      setInventoryInvoiceList(invoices || []);
    };
    loadInvoices();
  }, [reportType, inputs.from, inputs.to, inputs.year, inputs.month]);

  useEffect(() => {
    if (reportType !== "Inventory Stock Summary") return;
    const loadYears = async () => {
      const years = await getInventoryStockSummaryYears();
      setInventoryYearList(years || []);
    };
    loadYears();
  }, [reportType]);

  useEffect(() => {
    if (reportType !== "Inventory Stock Summary") return;
    const loadMonths = async () => {
      if (!inputs.year) {
        setInventoryMonthList([]);
        return;
      }
      const months = await getInventoryStockSummaryMonths(inputs.year);
      setInventoryMonthList(months || []);
    };
    loadMonths();
  }, [reportType, inputs.year]);

  useEffect(() => {
    if (reportType !== "Inventory Stock Summary") return;
    const loadInvoices = async () => {
      const invoices = await getInventoryStockSummaryInvoices({
        from: inputs.from,
        to: inputs.to,
        year: inputs.year,
        month: inputs.month,
      });
      setInventoryInvoiceList(invoices || []);
    };
    loadInvoices();
  }, [reportType, inputs.from, inputs.to, inputs.year, inputs.month]);

  useEffect(() => {
    if (reportType !== "Inventory Stock Summary") return;
    const loadYears = async () => {
      const years = await getInventoryStockSummaryYears();
      setInventoryYearList(years || []);
    };
    loadYears();
  }, [reportType]);

  useEffect(() => {
    if (reportType !== "Inventory Stock Summary") return;
    const loadMonths = async () => {
      if (!inputs.year) {
        setInventoryMonthList([]);
        return;
      }
      const months = await getInventoryStockSummaryMonths(inputs.year);
      setInventoryMonthList(months || []);
    };
    loadMonths();
  }, [reportType, inputs.year]);

  useEffect(() => {
    if (reportType !== "Inventory Stock Summary") return;
    const loadInvoices = async () => {
      const invoices = await getInventoryStockSummaryInvoices({
        from: inputs.from,
        to: inputs.to,
        year: inputs.year,
        month: inputs.month,
      });
      setInventoryInvoiceList(invoices || []);
    };
    loadInvoices();
  }, [reportType, inputs.from, inputs.to, inputs.year, inputs.month]);

  useEffect(() => {
    if (reportType !== "Shipment Number Wise Packing List Report") return;
    const loadShipments = async () => {
      const shipments = await getShipmentPackingListShipments({
        order_type: inputs.order_type || "All",
      });
      setShipmentNoList(shipments || []);
    };
    loadShipments();
  }, [reportType, inputs.order_type]);

  useEffect(() => {
    if (reportType !== "Shipment Number Wise Packing List Report") return;
    const loadBoxes = async () => {
      const boxes = await getShipmentPackingListBoxes({
        order_type: inputs.order_type || "All",
        shipment_no: inputs.shipment_no,
      });
      setBoxNoList(boxes || []);
    };
    loadBoxes();
  }, [reportType, inputs.order_type, inputs.shipment_no]);

  useEffect(() => {
    if (reportType !== "Shipment Number Wise Packing List Report") return;
    const loadPorts = async () => {
      const ports = await getShipmentPackingListPorts({
        order_type: inputs.order_type || "All",
        shipment_no: inputs.shipment_no,
        box_no: inputs.box_no,
      });
      setShipmentPortList(ports || []);
    };
    loadPorts();
  }, [reportType, inputs.order_type, inputs.shipment_no, inputs.box_no]);

  useEffect(async () => {
    if (reportType !== "Sales Report") return;
    try {
      const config = {
        withCredentials: true,
        headers: {
          withCredentials: true,
        },
      };
      const data = await axios.get(
        `${process.env.REACT_APP_URL}/api/reports/list-order-months?year=${inputs?.month_year}&gender=${inputs.gender}`,
        config
      );
      if (data?.status == 200) {
        setMnthList(data?.data?.result);
      }
    } catch (error) {
      // console.log(error);
    }
  }, [inputs.month_year, reportType]);

  useEffect(async () => {
    if (reportType !== "Sales Report") return;
    try {
      const config = {
        withCredentials: true,
        headers: {
          withCredentials: true,
        },
      };
      const data = await axios.get(
        `${process.env.REACT_APP_URL}/api/reports/list-order-year?gender=${inputs.gender}`,
        config
      );
      if (data?.status == 200) {
        setYearList(data?.data?.result);
      }
    } catch (error) {
      // console.log(error);
    }
    // dispatch(getAllOrders("", "", page));
  }, [inputs, reportType]);

  return (
    <Div>
      <Typography variant="h1" sx={{ mt: -4 }}>
        Report
      </Typography>
      <Div sx={{ width: "23%", minWidth: 260, mt: 3 }}>
        <Typography variant="h5">Report Type</Typography>
        <Select
          size="small"
          sx={{ width: "100%" }}
          value={reportType}
          onChange={handleReportTypeChange}
        >
          {REPORT_TYPES.map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </Select>
      </Div>
      <Div sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 3 }}>
        {reportType === "Sales Report" && (
          <>
        {/* <Div sx={{ width: "23%" }}>
          <Typography variant="h5">Select Order Type</Typography>
          <Select
            size="small"
            sx={{ width: "100%" }}
            value={inputs.order_type || ""}
            name="order_type"
            onChange={handleChange}
          >
            <MenuItem value={"Admin Order"}>Admin Order</MenuItem>
            <MenuItem value={"Cutting Order"}>Cutting Order</MenuItem>
            <MenuItem value={"Receive Order"}>Receive Order</MenuItem>
            <MenuItem value={"QC Order"}>QC Order</MenuItem>
            <MenuItem value={"Dispatch Order"}>Dispatch Order</MenuItem>
          </Select>
        </Div> */}
        {/* <Div>
          <Typography variant="h5">Todays Report</Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Div sx={{ width: "100%" }}>
              <DatePicker
                format="DD/MM/YY"
                value={inputs?.today}
                error={!inputs?.today}
                minDate={dayjs()}
                maxDate={dayjs()}
                onChange={(newDate) => (inputs.today = dateFun(newDate))}
                sx={{
                  width: "100%",
                  "&.MuiTextField-root": {
                    height: "39px",
                    flexDirection: "unset",
                  },
                }}
              />
            </Div>
          </LocalizationProvider>
        </Div> */}
        {/* <Div>
          <Typography variant="h5">Current Week Report</Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Div sx={{ width: "100%" }}>
              <DatePicker
                format="DD/MM/YY"
                value={inputs?.week}
                error={!inputs?.week}
                minDate={dayjs()}
                maxDate={dayjs()}
                onChange={(newDate) => (inputs.week = dateFun(newDate))}
                sx={{
                  width: "100%",
                  "&.MuiTextField-root": {
                    height: "39px",
                    flexDirection: "unset",
                  },
                }}
              />
            </Div>
          </LocalizationProvider>
        </Div> */}
        <Div sx={{ width: "23%" }}>
          <Typography variant="h5">Select Gender</Typography>
          <Select
            size="small"
            sx={{ width: "100%" }}
            value={inputs.gender || ""}
            name="gender"
            onChange={handleChange}
          >
            <MenuItem key={"male"} value={"male"}>
              Male
            </MenuItem>
            <MenuItem key={"female"} value={"female"}>
              Female
            </MenuItem>
          </Select>
        </Div>
        <Div sx={{ width: "23%" }}>
          <Typography variant="h5">Select Year</Typography>
          <Select
            size="small"
            sx={{ width: "100%" }}
            value={inputs.month_year || ""}
            name="month_year"
            onChange={handleChange}
          >
            {yearList?.map((item, i) => {
              return (
                <MenuItem key={i} value={item}>
                  {item}
                </MenuItem>
              );
            })}
          </Select>
        </Div>
        {/* {console.log(mnthList)} */}
        <Div sx={{ width: "23%" }}>
          <Typography variant="h5">Select Month</Typography>
          <Select
            size="small"
            sx={{ width: "100%" }}
            value={inputs.month || ""}
            name="month"
            onChange={handleChange}
          >
            {mnthList?.map((item, i) => {
              return (
                <MenuItem key={i} value={item?.month_name}>
                  {item.month_name}
                </MenuItem>
              );
            })}
          </Select>
        </Div>
        {/* <Div>
          <Typography variant="h5">From / To</Typography>
          <Div sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Div sx={{ width: "45%" }}>
                <DatePicker
                  format="DD/MM/YY"
                  value={inputs?.from}
                  error={!inputs?.from}
                  onChange={(newDate) => (inputs.from = dateFun(newDate))}
                  sx={{
                    width: "100%",
                    "&.MuiTextField-root": {
                      height: "39px",
                      flexDirection: "unset",
                    },
                  }}
                />
              </Div>
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Div sx={{ width: "45%" }}>
                <DatePicker
                  format="DD/MM/YY"
                  value={inputs?.to}
                  error={!inputs?.to}
                  onChange={(newDate) => (inputs.to = dateFun(newDate))}
                  sx={{
                    width: "100%",
                    "&.MuiTextField-root": {
                      height: "39px",
                      flexDirection: "unset",
                    },
                  }}
                />
              </Div>
            </LocalizationProvider>
          </Div>
        </Div> */}
          </>
        )}
        {(reportType === "Sales Order Report" ||
          reportType === "Receive Pending Order Report" ||
          reportType === "Alteration Report") && (
          <>
            <Div sx={fieldWidth}>
              <Typography variant="h5">From</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YY"
                  disabled={hasMonthYear}
                  value={inputs.from ? dayjs(inputs.from) : null}
                  onChange={(newDate) =>
                    setInputs((prev) => ({
                      ...prev,
                      from: newDate ? dateFun(newDate) : "",
                      year: "",
                      month: "",
                    }))
                  }
                  sx={pickerSx}
                />
              </LocalizationProvider>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">To</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YY"
                  disabled={hasMonthYear}
                  value={inputs.to ? dayjs(inputs.to) : null}
                  onChange={(newDate) =>
                    setInputs((prev) => ({
                      ...prev,
                      to: newDate ? dateFun(newDate) : "",
                      year: "",
                      month: "",
                    }))
                  }
                  sx={pickerSx}
                />
              </LocalizationProvider>
            </Div>
          </>
        )}
        {reportType === "Sales Order Report" && (
          <>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Select Year</Typography>
              <Select
                size="small"
                sx={{ width: "100%" }}
                value={inputs.year ? String(inputs.year) : ""}
                name="year"
                displayEmpty
                disabled={hasDateRange}
                onChange={handleChange}
              >
                <MenuItem value="">Select</MenuItem>
                {salesOrderYearList?.map((year) => (
                  <MenuItem key={year} value={String(year)}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Select Month</Typography>
              <Select
                size="small"
                sx={{ width: "100%" }}
                value={inputs.month || ""}
                name="month"
                displayEmpty
                disabled={hasDateRange || !inputs.year}
                onChange={handleChange}
              >
                <MenuItem value="">Select</MenuItem>
                {salesOrderMonthList?.map((item, i) => (
                  <MenuItem key={i} value={item?.month_name}>
                    {item?.month_name}
                  </MenuItem>
                ))}
              </Select>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Port No</Typography>
              <Autocomplete
                size="small"
                options={portList || []}
                value={inputs.port_no_and_name || null}
                getOptionLabel={(option) => option || ""}
                isOptionEqualToValue={(option, value) => option === value}
                onChange={(e, newValue) =>
                  setInputs((prev) => ({
                    ...prev,
                    port_no_and_name: newValue || null,
                  }))
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Sales Person Name</Typography>
              <Autocomplete
                size="small"
                options={salesPersonList || []}
                value={inputs.sales_person || null}
                getOptionLabel={(option) => {
                  if (option instanceof Object && !Array.isArray(option)) {
                    return option?.full_name || "";
                  }
                  return option || "";
                }}
                isOptionEqualToValue={(option, value) =>
                  String(option?.id) === String(value?.id)
                }
                onChange={(e, newValue) =>
                  setInputs((prev) => ({
                    ...prev,
                    sales_person: newValue || null,
                  }))
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option?.full_name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
            </Div>
          </>
        )}
        {reportType === "Receive Pending Order Report" && (
          <>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Select Year</Typography>
              <Select
                size="small"
                sx={{ width: "100%" }}
                value={inputs.year || ""}
                name="year"
                displayEmpty
                disabled={hasDateRange}
                onChange={handleChange}
              >
                <MenuItem value="">Select</MenuItem>
                {YEARS.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Select Month</Typography>
              <Select
                size="small"
                sx={{ width: "100%" }}
                value={inputs.month || ""}
                name="month"
                displayEmpty
                disabled={hasDateRange}
                onChange={handleChange}
              >
                <MenuItem value="">Select</MenuItem>
                {MONTHS.map((month) => (
                  <MenuItem key={month} value={month}>
                    {month}
                  </MenuItem>
                ))}
              </Select>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Factory Name</Typography>
              <Autocomplete
                size="small"
                options={factoryList || []}
                value={inputs.factory || null}
                getOptionLabel={(option) => option?.factory_name || ""}
                isOptionEqualToValue={(option, value) =>
                  String(option?.id) === String(value?.id)
                }
                onChange={(e, newValue) =>
                  setInputs((prev) => ({
                    ...prev,
                    factory: newValue || null,
                    factory_name: newValue?.factory_name || "",
                  }))
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option?.factory_name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Port Number & Name</Typography>
              <Autocomplete
                size="small"
                options={portList || []}
                value={inputs.port_no_and_name || null}
                getOptionLabel={(option) => option || ""}
                isOptionEqualToValue={(option, value) => option === value}
                onChange={(e, newValue) =>
                  setInputs((prev) => ({
                    ...prev,
                    port_no_and_name: newValue || null,
                  }))
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Sales Person Name</Typography>
              <Autocomplete
                size="small"
                options={salesPersonList || []}
                value={inputs.sales_person || null}
                getOptionLabel={(option) => {
                  if (option instanceof Object && !Array.isArray(option)) {
                    return option?.full_name || "";
                  }
                  return option || "";
                }}
                isOptionEqualToValue={(option, value) =>
                  String(option?.id) === String(value?.id)
                }
                onChange={(e, newValue) =>
                  setInputs((prev) => ({
                    ...prev,
                    sales_person: newValue || null,
                  }))
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option?.full_name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
            </Div>
          </>
        )}
        {reportType === "Alteration Report" && (
          <>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Select Year</Typography>
              <Select
                size="small"
                sx={{ width: "100%" }}
                value={inputs.year || ""}
                name="year"
                displayEmpty
                disabled={hasDateRange}
                onChange={handleChange}
              >
                <MenuItem value="">Select</MenuItem>
                {YEARS.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Select Month</Typography>
              <Select
                size="small"
                sx={{ width: "100%" }}
                value={inputs.month || ""}
                name="month"
                displayEmpty
                disabled={hasDateRange}
                onChange={handleChange}
              >
                <MenuItem value="">Select</MenuItem>
                {MONTHS.map((month) => (
                  <MenuItem key={month} value={month}>
                    {month}
                  </MenuItem>
                ))}
              </Select>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Factory</Typography>
              <Autocomplete
                size="small"
                options={factoryList || []}
                value={inputs.factory || null}
                getOptionLabel={(option) => option?.factory_name || ""}
                isOptionEqualToValue={(option, value) =>
                  String(option?.id) === String(value?.id)
                }
                onChange={(e, newValue) =>
                  setInputs((prev) => ({
                    ...prev,
                    factory: newValue || null,
                    factory_name: newValue?.factory_name || "",
                  }))
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option?.factory_name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Port No - Name</Typography>
              <Autocomplete
                size="small"
                options={portList || []}
                value={inputs.port_no_and_name || null}
                getOptionLabel={(option) => option || ""}
                isOptionEqualToValue={(option, value) => option === value}
                onChange={(e, newValue) =>
                  setInputs((prev) => ({
                    ...prev,
                    port_no_and_name: newValue || null,
                  }))
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Status</Typography>
              <Select
                size="small"
                sx={{ width: "100%" }}
                value={inputs.order_item_status || ""}
                name="order_item_status"
                displayEmpty
                onChange={handleChange}
              >
                <MenuItem value="">Select</MenuItem>
                {(alterationStatusList || []).map((status) => (
                  <MenuItem key={status} value={status}>
                    {status}
                  </MenuItem>
                ))}
              </Select>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Sales Person Name</Typography>
              <Autocomplete
                size="small"
                options={salesPersonList || []}
                value={inputs.sales_person || null}
                getOptionLabel={(option) => {
                  if (option instanceof Object && !Array.isArray(option)) {
                    return option?.full_name || "";
                  }
                  return option || "";
                }}
                isOptionEqualToValue={(option, value) =>
                  String(option?.id) === String(value?.id)
                }
                onChange={(e, newValue) =>
                  setInputs((prev) => ({
                    ...prev,
                    sales_person: newValue || null,
                  }))
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option?.full_name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
            </Div>
          </>
        )}
        {(reportType === "Job Work Issue Details Report" ||
          reportType === "Job Work Draft Report") && (
          <>
            <Div sx={fieldWidth}>
              <Typography variant="h5">From Date</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YY"
                  value={inputs.from ? dayjs(inputs.from) : null}
                  onChange={(newDate) =>
                    setInputs((prev) => ({
                      ...prev,
                      from: newDate ? dateFun(newDate) : "",
                    }))
                  }
                  sx={pickerSx}
                />
              </LocalizationProvider>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">To Date</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YY"
                  value={inputs.to ? dayjs(inputs.to) : null}
                  onChange={(newDate) =>
                    setInputs((prev) => ({
                      ...prev,
                      to: newDate ? dateFun(newDate) : "",
                    }))
                  }
                  sx={pickerSx}
                />
              </LocalizationProvider>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Year</Typography>
              <Select
                size="small"
                sx={{ width: "100%" }}
                value={inputs.year || ""}
                name="year"
                displayEmpty
                onChange={handleChange}
              >
                <MenuItem value="">Select</MenuItem>
                {YEARS.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Month</Typography>
              <Select
                size="small"
                sx={{ width: "100%" }}
                value={inputs.month || ""}
                name="month"
                displayEmpty
                onChange={handleChange}
              >
                <MenuItem value="">Select</MenuItem>
                {MONTHS.map((month) => (
                  <MenuItem key={month} value={month}>
                    {month}
                  </MenuItem>
                ))}
              </Select>
            </Div>
            {reportType === "Job Work Issue Details Report" && (
            <Div sx={fieldWidth}>
              <Typography variant="h5">Factory Name</Typography>
              <Autocomplete
                size="small"
                options={Array.isArray(factoryList) ? factoryList : []}
                value={
                  (Array.isArray(factoryList) ? factoryList : []).find(
                    (item) =>
                      String(item.id) === String(inputs.factory_id) ||
                      item.factory_name === inputs.factory_name
                  ) || null
                }
                getOptionLabel={(option) => option?.factory_name || ""}
                isOptionEqualToValue={(option, value) =>
                  String(option?.id) === String(value?.id)
                }
                onChange={(e, newValue) =>
                  setInputs((prev) => ({
                    ...prev,
                    factory_id: newValue?.id || "",
                    factory_name: newValue?.factory_name || "",
                  }))
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option?.factory_name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
            </Div>
            )}
          </>
        )}
        {reportType === "Shipment Number Wise Packing List Report" && (
          <>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Order Type</Typography>
              <Select
                size="small"
                sx={{ width: "100%" }}
                value={inputs.order_type || "All"}
                name="order_type"
                onChange={(event) =>
                  setInputs((prev) => ({
                    ...prev,
                    order_type: event.target.value,
                    shipment_no: null,
                    box_no: null,
                    shipment_port_no: null,
                  }))
                }
              >
                {ORDER_TYPES.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Shipment No</Typography>
              <Autocomplete
                size="small"
                options={shipmentNoList || []}
                value={inputs.shipment_no || null}
                getOptionLabel={(option) => option || ""}
                isOptionEqualToValue={(option, value) => option === value}
                onChange={(e, newValue) =>
                  setInputs((prev) => ({
                    ...prev,
                    shipment_no: newValue || null,
                    box_no: null,
                    shipment_port_no: null,
                  }))
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Box No</Typography>
              <Autocomplete
                size="small"
                options={boxNoList || []}
                value={inputs.box_no || null}
                getOptionLabel={(option) => option || ""}
                isOptionEqualToValue={(option, value) => option === value}
                onChange={(e, newValue) =>
                  setInputs((prev) => ({
                    ...prev,
                    box_no: newValue || null,
                    shipment_port_no: null,
                  }))
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Port No</Typography>
              <Autocomplete
                size="small"
                options={shipmentPortList || []}
                value={inputs.shipment_port_no || null}
                getOptionLabel={(option) => option || ""}
                isOptionEqualToValue={(option, value) => option === value}
                onChange={(e, newValue) =>
                  setInputs((prev) => ({
                    ...prev,
                    shipment_port_no: newValue || null,
                  }))
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
            </Div>
          </>
        )}
        {reportType === "Inventory Stock Summary" && (
          <>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Invoice Date From</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YY"
                  disabled={hasMonthYear}
                  value={inputs.from ? dayjs(inputs.from) : null}
                  onChange={(newDate) =>
                    setInputs((prev) => ({
                      ...prev,
                      from: newDate ? dateFun(newDate) : "",
                      year: "",
                      month: "",
                      invoice_no: null,
                    }))
                  }
                  sx={pickerSx}
                />
              </LocalizationProvider>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Invoice Date To</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YY"
                  disabled={hasMonthYear}
                  value={inputs.to ? dayjs(inputs.to) : null}
                  onChange={(newDate) =>
                    setInputs((prev) => ({
                      ...prev,
                      to: newDate ? dateFun(newDate) : "",
                      year: "",
                      month: "",
                      invoice_no: null,
                    }))
                  }
                  sx={pickerSx}
                />
              </LocalizationProvider>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Invoice Year</Typography>
              <Select
                size="small"
                sx={{ width: "100%" }}
                value={inputs.year ? String(inputs.year) : ""}
                name="year"
                displayEmpty
                disabled={hasDateRange}
                onChange={(event) =>
                  setInputs((prev) => ({
                    ...prev,
                    year: event.target.value,
                    month: "",
                    from: "",
                    to: "",
                    invoice_no: null,
                  }))
                }
              >
                <MenuItem value="">All</MenuItem>
                {inventoryYearList?.map((year) => (
                  <MenuItem key={year} value={String(year)}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Invoice Month</Typography>
              <Select
                size="small"
                sx={{ width: "100%" }}
                value={inputs.month || ""}
                name="month"
                displayEmpty
                disabled={hasDateRange || !inputs.year}
                onChange={handleChange}
              >
                <MenuItem value="">All</MenuItem>
                {inventoryMonthList?.map((item, i) => (
                  <MenuItem key={i} value={item?.month_name}>
                    {item?.month_name}
                  </MenuItem>
                ))}
              </Select>
            </Div>
            <Div sx={fieldWidth}>
              <Typography variant="h5">Invoice No</Typography>
              <Autocomplete
                size="small"
                options={inventoryInvoiceList || []}
                value={inputs.invoice_no || null}
                getOptionLabel={(option) => option || ""}
                isOptionEqualToValue={(option, value) => option === value}
                onChange={(e, newValue) =>
                  setInputs((prev) => ({
                    ...prev,
                    invoice_no: newValue || null,
                  }))
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="All"
                  />
                )}
              />
            </Div>
          </>
        )}
      </Div>
      {/* apply and clear */}
      <Div sx={{ display: "flex", alignItems: "center", mt: 4 }}>
        <Button
          disabled={
            reportType === "Sales Report" && inputs["month_year"] === undefined
          }
          size="small"
          variant="contained"
          sx={{ p: 1, pl: 4, pr: 4, marginRight: 2 }} // Adjust marginRight for spacing
          onClick={handleFilter}
        >
          {reportType === "Receive Pending Order Report" ||
          reportType === "Job Work Issue Details Report" ||
          reportType === "Job Work Draft Report" ||
          reportType === "Alteration Report"
            ? "Apply"
            : "Apply & Import"}
        </Button>
        <Button
          size="small"
          variant="outlined"
          sx={{ p: 1, pl: 4, pr: 4 }}
          onClick={handleClear}
        >
          Clear
        </Button>
      </Div>
    </Div>
  );
};

export default SalesYearlyReport;
